import { render, staticRenderFns } from "./ShippingCroboOrder.vue?vue&type=template&id=925d1324&scoped=true&"
import script from "./ShippingCroboOrder.vue?vue&type=script&lang=js&"
export * from "./ShippingCroboOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShippingCroboOrder.vue?vue&type=style&index=0&id=925d1324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925d1324",
  null
  
)

export default component.exports